import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { Route, Routes, useParams } from 'react-router-dom';
import LoadingPackage from '../../../Common/LoadingPackage';
import { ContainerContext } from '../../../../../context/ContainerContext';
import ContainerInfoPane from './ContainerInfoPane';
import NotFound from '../../../../../assets/html/notFound';
import { Routing } from '../../../../../util/routes.util';
import { Breadcrumbs, ContainerOverviewCrumb, Crumb } from '../../../../components/Breadcrumbs';
import { Tab, Tabs } from '../../../../components/Tabs';
import UpdateContainerPane from './UpdateContainerPane';

export default function ContainerDetailScreen({}) {
  const id = useParams()['id'] || '';

  const { containers, containersLoading } = useContext(ContainerContext);
  const container = containers.get(id);

  if (!container) {
    return (
      <div className='flex h-full items-center justify-center'>
        {containersLoading ? <LoadingPackage /> : <NotFound />}
      </div>
    );
  }

  return (
    <div className='flex h-full flex-col'>
      <Breadcrumbs>
        <ContainerOverviewCrumb />
        <Crumb text={container.identifier} path={Routing.stock.containers.detail(container.id)} current />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex flex-grow flex-col'>
        <Tabs padding>
          <Tab text={t(TranslationKey.info).singular.label} path='info' key='info' />
          <Tab text={t(TranslationKey.configuration).singular.label} path='configuration' key='configuration' />
        </Tabs>
        <Routes>
          <Route path='info' element={<ContainerInfoPane container={container} />} />
          <Route path='configuration' element={<UpdateContainerPane container={container} />} />
        </Routes>
      </div>
    </div>
  );
}
